import { createDialog } from '../../../dialogs/dialogs';
import { nuiCtx } from '../../../../common/initialization';
import React from 'react';
import SuccessDialogBody from '../../../dialogs/SuccessDialogBody';

const KycSuccessDialog = createDialog({
    name: 'kyc-success-dialog',
    component: ({ close }) => {
        const { NuiDialog } = nuiCtx.components;
        return (
            <NuiDialog mobileMode="DOCKED" name="kyc-form-dialog" className="kyc-form-dialog modal-sm" onClose={close}>
                <SuccessDialogBody
                    i18nTitleCode={'nui.kyc.success.dialog.title'}
                    i18nTextCode={'nui.kyc.success.dialog'}
                    close={close}
                />
            </NuiDialog>
        );
    }
});

export default KycSuccessDialog;
